import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatService } from '../../services/chat.service';
import { ChatMessage } from '../../services/chat-message';

@Component({
  selector: 'app-chat-history',
  templateUrl: './chat-history.component.html',
  styleUrls: ['./chat-history.component.scss'],
  standalone: false
})
export class ChatHistoryComponent {
  @Input() messages: ChatMessage[] = [];

  constructor() {}
}
